module.exports = __webpack_public_path__ + "assets/img/Windows.94abad61.svg";